import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DeleteIcon } from '../../assets/icons/cancel.svg';
import UserContext from '../../context/UserContext';
import axios from 'axios';
import PayContext from '../../context/PayContext';
import { useFetcher } from '../../hooks/useFetcher';

const ShopingCart = () => {
  const navigate = useNavigate();
  const { setPaymentData } = useContext(PayContext);
  const { user, setUser } = useContext(UserContext);
  const [data, setData] = useState(null);
  const [count, setCount] = useState(0);
  const [warningMessage,setWarningMessage]=useState('');
  const [errorMessage,setErrorMessage]=useState('');
  const [cartLoading, setCartLoading] = useState(false);
  const cartData=JSON.stringify(JSON.parse(localStorage.getItem('products')).map((item)=>{
    return item.id
  }));
  
  const[cartI,loading]=useFetcher(`products/batch?pids=${cartData}`,"POST");

  function toFarsiNumber(n) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return (parseInt(n).toLocaleString().toString().replace(/\d/g, (x) => farsiDigits[x]));
  };

  const discountCalculator = (originalPrice, discount) => {
    return (originalPrice - (originalPrice * discount) / 100).toFixed(0);
  };

  const discountValue = (originalPrice, discount) => {
    return (originalPrice * discount) / 100;
  };

  const increase = (target) => {
    
    setCount((prev) => prev + 1);
    const products = JSON.parse(localStorage.getItem('products'));
    products.map((item) => {
      console.log( item.count);
      const maxCartSelectable=localStorage.getItem('maxCart');
      item.id === target.id && item.pcount - 1 > item.count && maxCartSelectable > item.count
        ? (item.count = (+item.count || 1) + 1)
        : (item.count = item.count || 1);
      return item;
    });
    localStorage.setItem('products', JSON.stringify(products));
  };

  const decrease = (target) => {
    setCount((prev) => prev - 1);
    const products = JSON.parse(localStorage.getItem('products'));
    products.map((item) => {
      item.id === target.id
        ? (item.count = (+item.count || 1) - 1)
        : (item.count = item.count || 1);
      return item;
    });

    localStorage.setItem('products', JSON.stringify(products));
  };

  const onClick = (e) => {
    setCartLoading(true);
    e.preventDefault();
    e.preventDefault();
    console.log(user);
    let doing=true;
    data.forEach(item => {
      if(item.isAvailable==0){
        alert("محصول ناموجود در سبد خریدتان است.");
        setCartLoading(false);
        doing=false;
      }
      if(item.count>=item.pcount){
        alert("تعداد انتخابی برخی از محصولات بیشتر از موجودی فروشگاه است.\n یه باکس های قرمز توجه کنید");
        setCartLoading(false);
        doing=false
      }
    });
    if(doing){
    if (!(user?.data?.id)) {
      navigate('/register');
    }
    const endpoint = '/api/orders/ride-options';

    

    // Total price
    const prices = data.map((item) => {
      return discountCalculator(item.price, item.offrate) * item.count;
    });
    const totalPrice = prices.reduce((prev, curr) => prev + curr, 0);
    // Original price
    const originalPrices = data.map((item) => {
      return item.price * item.count;
    });
    const originalPrice = originalPrices.reduce((prev, curr) => prev + curr, 0);
    // Total dicount
    const totalDiscountes = data.map((item) => {
      return discountValue(item.price, item.offrate) * item.count;
    });
    const totalDiscount = totalDiscountes.reduce(
      (prev, curr) => prev + curr,
      0
    );
    // Cart
    const cart = data.map((item) => {
      return { id: item.id, count: item.count };
    });
    // Off Code
    const offCode = '';
    // Offiliation Id
    const affiliation_id = '1';

    const formData = new FormData();

    formData.append('totalPrice', totalPrice.toString());
    formData.append('cart', JSON.stringify(cart));
    formData.append('offcode', offCode);
    formData.append('affiliation_id', affiliation_id);
    formData.append('web','');

    const fetcher = async () => {
      // try {
      const res = await axios({
        method: 'post',
        url: endpoint,
        data: formData,
        withCredentials: true,
        // baseURL: 'https://hamrahyper.ir',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });

      if (res.status === 200) {
        setPaymentData({
          ...res.data,
          totalPrice,
          originalPrice,
          totalDiscount,
        });
        if(res.data.warningMessage=='' && res.data.errorMessage=='')
        {
          navigate('/payment');
        }
        else if(res.data.errorMessage!=''){
          setErrorMessage(res.data.errorMessage);
        }
        else{
          setWarningMessage(res.data.warningMessage);
        }
      }
    };

    fetcher()
  }
  };

  const onResetForm=(e) => {
    localStorage.setItem('products', JSON.stringify(data.filter(() => false)));
    console.log(data.filter(() => false))
    setData(data.filter(() => false));
    setCount(0);
    document.querySelector(".cart-number").innerHTML=0;
  };

  const delteHandler = (id) => {
    const lsData = JSON.parse(localStorage.getItem('products'));

    const newProducts = lsData.filter((item) => item.id !== id);

    if (window.confirm('حذف شود؟')) {
      console.log(newProducts)
      localStorage.setItem('products', JSON.stringify(newProducts));
      let counterss=0
      newProducts.map(()=>{
      counterss++;
    })
    document.querySelector(".cart-number").innerHTML=counterss;
      setCount((prev) => prev + 1);
    }
  };
  


  useEffect(() => {
    if(!loading){
      if(cartI){
      const productsTMP=JSON.parse(localStorage.getItem('products'));
    
        productsTMP.map((item) => {
            if (!item.count) item.count = 1;
            return item;
          });
          
          let cartTMP=[];
          
          for (let i = 0; i < productsTMP.length; i++) {
            for (let j = 0; j < cartI.length; j++) {
              if(cartI[j].id==productsTMP[i].id)
              {
                cartTMP=[...cartTMP,cartI[j]]
              }
            }
          }
          
          for (let i = 0; i < productsTMP.length; i++) {
              if(cartTMP[i].id==productsTMP[i].id)
              {
                if(cartTMP[i].isAvailable==0) 
                cartTMP[i].count=0
                else
                cartTMP[i].count=productsTMP[i].count
              }
          }

          localStorage.setItem('products', JSON.stringify(cartTMP));

          setData(cartTMP);
      }
    }
  }, [count,loading]);

  return (
    <>
    {warningMessage && <div className='warning-message-full' onClick={(e) =>{if(e.target===e.currentTarget) setWarningMessage(''); setCartLoading(false)}}>
      <div class="bg-blue-100 border border-orange-500 text-blue-700 px-4 py-3 md:w-1/2 w-3/4 text-right" role="alert">
        <p class="font-bold text-center border-b border-slate-500 w-3/4 m-auto pb-1">توجه</p>
        <p class="text-sm">{warningMessage}</p>
        <div className='flex flex-col w-fit m-auto'><button onClick={() => navigate('/payment')} className='text-center bg-green-800 text-white p-2 px-10 rounded-lg'>موافقم</button></div>
      </div>
    </div>}
    {errorMessage && <div className='warning-message-full' onClick={(e) =>{if(e.target===e.currentTarget) setErrorMessage(''); setCartLoading(false)}}>
      <div class="bg-red-100 border border-orange-500 text-blue-700 px-4 py-3 md:w-1/2 w-3/4 text-right" role="alert">
        <p class="font-bold text-center border-b border-slate-500 w-3/4 m-auto pb-1 align-rtl">خطا...</p>
        <p class="text-sm">{errorMessage}</p>
        <div className='flex flex-col w-fit m-auto'><button onClick={() => {setErrorMessage(''); setCartLoading(false)}} className='text-center bg-green-800 text-white p-2 px-10 rounded-lg'>تایید</button></div>
      </div>
    </div>}
    <form className='my-auto w-full px-5 mt-5' onSubmit={onClick} onReset={onResetForm}>
      <div className='w-full flex flex-col justify-between items-center gap-5'>
        {data &&
          data.map((item, index) => (
            <div
              key={item.id}
              className={`w-full flex flex-col justify-between items-center gap-5 p-5  rounded-lg cursor-pointer xsm:flex-row-reverse xsm:gap-0 ${(!item.isAvailable?'bg-slate-500':(item.count>=item.pcount?'bg-red-300':'bg-blue-300'))} `}
              onClick={() => navigate(`/product/${item.id}`)}>
              <img className='w-20' src={item.thumb || item.image} alt='' />

              <p className='w-72 text-center xsm:text-right'>{item.name}</p>

              {item.offrate > 0 ? (
                <div className='w-44 flex flex-row-reverse justify-center gap-1 text-right'>
                  <span className='text-right'>
                    {toFarsiNumber(
                      discountCalculator(item.price, item.offrate)
                    )}
                  </span>
                  <span>تومان</span>
                </div>
              ) : (
                <div
                  className={`w-44 flex flex-row-reverse justify-center items-center gap-1 ${
                    item.offrate > 0 ? 'line-through text-gray-700' : ''
                  }`}>
                  <span className='text-center'>
                   {toFarsiNumber(item.price)}
                  </span>
                  <span>تومان</span>
                </div>
              )}

              <div className='w-fit flex justify-between px-5 gap-0.5'>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    decrease(item);
                  }}
                  className='w-6 bg-gray-300 px-2 rounded-sm'>
                  -
                </button>
                <span
                  className='w-fit bg-gray-200 px-2 rounded-sm'
                  style={{ minWidth: '1.5rem' }}>
                  {item.count || 1}
                </span>

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    increase(item);
                  }}
                  className='w-6 bg-gray-300 px-2 rounded-sm'>
                  +
                </button>
              </div>

              <DeleteIcon
                className='cursor-pointer'
                onClick={(e) => {
                  e.stopPropagation();
                  delteHandler(item.id);
                }}
              />
            </div>
          ))}
          {console.log(data)}
          {(data==null || (Array.isArray(data) && data.length==0)) && <div className='text-xl border-2 border-slate-400 p-2 border-dashed w-52 text-center'>سبد خرید خالی است</div>}
      </div>

      <div className='w-full flex flex-col gap-3 justify-between items-center my-5 xsm:flex-row'>
        <button
          className='text-center bg-green-800 text-white p-2 px-10 rounded-lg disabled:opacity-50'
          type='submit'
          disabled={(data==null || (Array.isArray(data) && data.length==0))}
          >
            {
              cartLoading &&
              (<div className='lds-dual-ring-btn' ></div>)
            }
            {
              !cartLoading &&
              (<>نهایی کردن سفارش</>)
            }
          
        </button>
        <button
          className='text-center bg-light text-dark p-2 px-10 rounded-lg border-black border-2 disabled:bg-slate-500'
          type='reset'
          disabled={(data==null || (Array.isArray(data) && data.length==0))}
          >
            پاک کردن سبد خرید
          
        </button>
        <div className='flex items-center'>
          <p>تومان</p>
          <p className='mx-1 mr-5'>
            {data &&
              toFarsiNumber(
                data
                  .map((item) => {
                    return (
                      discountCalculator(item.price, item.offrate) * item.count
                    );
                  })
                  .reduce((prev, curr) => prev + curr, 0)
              )}
          </p>
          <h2 className='text-lg'> :قیمت کل</h2>
        </div>
      </div>
    </form>
    </>
  );
};

export default ShopingCart;
